@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.date-picker-wrapper {
  display: inline-block;
}

.link-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 13px;
  cursor: pointer;
  width: 60px;
  .icon-wrapper {
    > svg {
      height: 30px;
      width: 30px;
      min-width: 30px;
      transition: all 300ms ease;
      fill: @link-date-picker--fill-color;
    }
  }

  &:hover {
    text-decoration: none;
    color: @link-date-picker--hover--text-color;

    svg {
      fill: @link-date-picker--hover--fill-color;
    }
  }
}

.icon-wrapper {
  height: 30px;
  width: 30px;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    width: 8px;
  }
}

.toggled {
  outline: none;
  background-color: transparent;
  border-radius: 3px;

  .icon-wrapper {
    > svg {
      transform: rotate(-180deg);
    }
  }
}
